import { API_URL } from "@/config";
import { axios } from '@/lib/axios';
import { TagsResponse } from '../types';

export const getTags = (): Promise<TagsResponse> => {
    return axios.get(`${API_URL}/api/free/tag_list`);
};
